<template>
  <slice
    :id="block._key"
    class="slice--iframe"
    :class="{ container: block.is_full, boxed: !block.height_auto }"
    @in="$emit('in')"
    @out="$emit('out')"
  >
    <div class="row-md justify-center">
      <div :class="block.is_full ? 'col-md-12' : 'col-md-10'">
        <div class="inner p-relative">
          <div v-if="block.iframe" v-html="block.iframe"></div>
        </div>
      </div>
    </div>
  </slice>
</template>

<script>
import Slice from '@/components/Slices/Slice'

export default {
  title: 'BlockIframe',
  components: { Slice },
  props: {
    block: { type: Object, required: true },
  },
}
</script>

<style lang="scss">
.slice--iframe.boxed {
  .inner {
    padding-bottom: 125%;

    @include mq($from: tablet) {
      padding-bottom: 45%;
    }
  }

  iframe {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }
}
</style>
